/**
 * How long ago a rider's phone said where it was.
 *
 * WHY THE AGE AND NOT THE POSITION
 * --------------------------------
 * A dispatcher deciding who gets the next order does not read coordinates.
 * What they need to know is whether the position is worth trusting: "nine
 * minutes ago" means the rider is out there with the app open, and a position
 * from two hours ago means any dot drawn from it is a lie.
 *
 * This app reports only while a rider has it open, so a stale reading is the
 * ordinary consequence of a phone in a pocket — not a fault, but something the
 * person handing out work has to be able to see.
 */

/** How long ago this rider's phone reported, in words. */
export function lastSeen(rider, now = Date.now()) {
  if (!rider?.last_seen_at) return 'Location not shared';

  // Stored without a zone, like every timestamp here, and read as UTC.
  const at = Date.parse(String(rider.last_seen_at).replace(' ', 'T') + 'Z');
  if (Number.isNaN(at)) return 'Location not shared';

  const minutes = Math.floor((now - at) / 60_000);

  if (minutes < 1) return 'Here just now';
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  // Past an hour the dot is not worth reading, so it says so rather than
  // counting up politely.
  return hours < 24 ? `${hours}h ago — probably stale` : 'Not seen today';
}
